import { figmaDefaultIconSize, figmaIconSizes, type FigmaIconSizeVariation } from '../../../core/tokens/icons';
import type { IconSize } from '../../../core/types/theme';

const asIconSize = <Size extends IconSize>(size: Size) => size;
const asFigmaIconSize = <Size extends FigmaIconSizeVariation>(size: Size) => size;

// AdminCommon intentionally keeps a small local seam so primitives can stay aligned
// with shared icon tokens while still allowing design-language drift where needed.
export const ADMIN_COMMON_CANONICAL_ICON_SIZES = figmaIconSizes;
export const ADMIN_COMMON_DEFAULT_ICON_SIZE = asFigmaIconSize(figmaDefaultIconSize);

export const ADMIN_COMMON_ICON_SIZES = {
  navTabChevron: asIconSize(12),
} as const;
